export class DeleteFleetDefinitionRequest {
    fleetId?: string;
}